export default {
  name: 'crmLeads',
  namespace: 'portal_leads',
  methods: [
    {
      name: 'find',
      params: ['id'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace, id }) => `/v1/crm/${namespace}/${id}/`,
      urlParams: ['id']
    },
    {
      name: 'filter',
      params: ['data'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/crm/${namespace}/`,
      urlParams: []
    }
  ]
}